// Definición de defaults

export const defaultAutoridadResolutoria: AutoridadResolutoriaProps = {
    idAutoridadResolutoria: 0,
    descripcion:            '',
    activo:                 false,
}

// Creación de interfaces

export interface AutoridadResolutoriaProps {
    idAutoridadResolutoria:        number;
    descripcion:                   string;
    activo:                        boolean;
}